import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { preset } from 'vue-cli-plugin-vuetify-preset-rally/preset'

Vue.use(Vuetify)

const options = {
   theme: {
     //dark: true,
     themes: {
      light: {
        headline: {
          fontFamily: '"Oswald", sans-serif !important',
        },
      },
      dark: {
        headline: {
          fontFamily: '"Oswald", sans-serif !important',
        },
      },
    },
   },
  customProperties: true,
  defaultAssets: {
    font: 'Open Sans, sans-serif !important', 
  },
}

const vuetify = new Vuetify({ preset, ...options })

export default vuetify
